import React from 'react';
import { connect } from "react-redux";
import MonacoEditor from "react-monaco-editor";
import { throttle } from 'lodash';

import { getEditorValue } from '../store/reducers';
import { setEditorValue } from '../store/actions';

const editorOptions = {
  // wordBasedSuggestions: true,
  // snippetSuggestions: true,
  minimap: {
    enabled: false
  },
  automaticLayout: true,
  folding: true,
  scrollBeyondLastLine: false,
  wordWrap: "on"
};


class InputPane extends React.Component {

  componentDidMount() {
    this.throttled = throttle(function(value) {
      this.props.setEditorValue(value);
    }, 250);
  }

  editorDidMount(editor, monaco) {
    editor.focus();
  }

  componentDidCatch(error, info) {
    console.log(info);
    console.error(error)
  }

  onChange = newValue => {
    this.throttled(newValue);
  };

  render() {
    const editorProps = {
      theme: "vs-dark",
      language: "plaintext",
      options: editorOptions,
      value: this.props.editorValue,
      editorDidMount: this.editorDidMount,
      onChange: this.onChange
    };
    return (<MonacoEditor {...editorProps} /> );
  }
}


const mapStateToProps = (state) => ({
  editorValue: getEditorValue(state)
});

const mapDispatchToProps = {
  setEditorValue
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InputPane);
